import { useState, useRef, useEffect } from 'react'

const DEFAULT_INACTIVITY_TIMEOUT = 30 * 1000 // 30 seconds
const EXTENDED_INACTIVITY_TIMEOUT = 3 * 60 * 1000 // 3 minutes

export const useInactivity = (currentScreen, excludedScreens, extendedTimeoutScreens = []) => {
  const [showInactivityModal, setShowInactivityModal] = useState(false)
  const inactivityTimerRef = useRef(null)

  const getTimeoutForScreen = (screen) => {
    if (extendedTimeoutScreens.includes(screen)) {
      return EXTENDED_INACTIVITY_TIMEOUT
    }
    return DEFAULT_INACTIVITY_TIMEOUT
  }

  const resetInactivityTimer = () => {
    if (!excludedScreens.includes(currentScreen)) {
      if (inactivityTimerRef.current) {
        clearTimeout(inactivityTimerRef.current)
      }

      const timeout = getTimeoutForScreen(currentScreen)
      inactivityTimerRef.current = setTimeout(() => {
        setShowInactivityModal(true)
      }, timeout)
    }
  }

  useEffect(() => {
    const handleUserActivity = () => {
      if (showInactivityModal) {
        return
      }
      resetInactivityTimer()
    }

    window.addEventListener('mousemove', handleUserActivity)
    window.addEventListener('mousedown', handleUserActivity)
    window.addEventListener('keypress', handleUserActivity)
    window.addEventListener('touchstart', handleUserActivity)
    window.addEventListener('scroll', handleUserActivity)

    resetInactivityTimer()

    return () => {
      window.removeEventListener('mousemove', handleUserActivity)
      window.removeEventListener('mousedown', handleUserActivity)
      window.removeEventListener('keypress', handleUserActivity)
      window.removeEventListener('touchstart', handleUserActivity)
      window.removeEventListener('scroll', handleUserActivity)

      if (inactivityTimerRef.current) {
        clearTimeout(inactivityTimerRef.current)
      }
    }
  }, [currentScreen, showInactivityModal])

  useEffect(() => {
    setShowInactivityModal(false)
    resetInactivityTimer()
  }, [currentScreen])

  const handleStayActive = () => {
    setShowInactivityModal(false)
    resetInactivityTimer()
  }

  return {
    showInactivityModal,
    handleStayActive,
  }
}
